import { toLocaleDate } from "@/utils/dates";
import { toGroupedTooltipTask, getTaskableLabel } from "@/utils/transforms";
import store from "@/store";

export const getVirtualValue = (virtualField, item) => {
    let ret = "";
    const registry = item?.insurance_policy?.registry;
    let notes;
    const task_type = 2; // note
    // TODO estrarre le note anche del titolo
    notes = (
        item.tasks ? item.tasks.filter((e) => e.task_type.value === task_type) : []
    )
        .concat(
            registry?.tasks
                ? registry.tasks.filter((e) => e.task_type.value === task_type)
                : []
        )
        .concat(
            item.insurance_policy && item.insurance_policy.tasks
                ? item.insurance_policy.tasks.filter(
                    (e) => e.task_type.value === task_type
                )
                : []
        );

    if (item.insurance_policy) {
        switch (virtualField) {
            case "info":
                ret = {
                    notes: notes_tooltip(notes),
                    notes_counter: notes_counter(notes),
                };
                break;
            default:
                console.info("WARNING: unknown virtualField ", virtualField);
                ret = "";
        }
    } else {
        console.info(
            "WARNING: payments getVirtualValue - data or ancillary or ancillary.insurance_policy is undefined"
        );
    }
    return ret;
};

export const notes_counter = (array) => {
    let ret = {
        header: "Quantità",
        content: array.length,
    };
    return ret;
};

const getOwner = (value) => {
    if (!value) return "-";
    return (
        store.state.auth.users.find((user) => user.id === value)?.username ?? "-"
    );
};

export const notes_tooltip = (array) => {
    // crea un nuovo attributo "entity" nel array originale
    for (let item of array) {
        item["entity"] = getTaskableLabel(item.pivot.taskable_type);
    }
    if (array.length) {
        array.forEach((note) => {
            if (!Object.prototype.hasOwnProperty.call(note, "owner"))
                note.owner = getOwner(note.owner_id);
            if (note?.last_update && note.last_update.indexOf("-") > 0)
                note.last_update = toLocaleDate(
                    note.last_update,
                    "DD/MM/YYYY HH:mm:ss"
                );
            if (note?.created_at && note.created_at.indexOf("-") > 0)
                note.created_at = toLocaleDate(note.created_at, "DD/MM/YYYY HH:mm:ss");
        });
    }
    return {
        header: "Note (tooltip)",
        content: toGroupedTooltipTask(array),
        rawData: array,
    };
};